import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Instrument_Serif, Sofia_Sans_Extra_Condensed } from 'next/font/google'
import { MotionConfig } from 'motion/react'
import { SmoothScroll } from '@/components/motion/smooth-scroll'
import { Navbar } from '@/components/site/navbar'
import { Footer } from '@/components/site/footer'

const sans = Sofia_Sans_Extra_Condensed({
    subsets: ['latin', 'latin-ext'],
    style: ['normal', 'italic']
})

const serif = Instrument_Serif({
    subsets: ['latin', 'latin-ext'],
    weight: '400',
    style: ['normal', 'italic']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:ui-monospace, SFMono-Regular, Menlo, monospace;--font-app-heading:${sans.style.fontFamily};--font-app-serif:${serif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='flex min-h-full flex-col font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1' />
            </Head>

            <MotionConfig reducedMotion='user'>
                <SmoothScroll>
                    <a
                        href='#main'
                        className='sr-only z-[60] bg-primary px-4 py-3 text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
                    >
                        Skip to content
                    </a>

                    <Navbar />

                    <Component {...pageProps} />

                    <Footer />
                </SmoothScroll>
            </MotionConfig>
        </div>
    )
}

export default App
